import Vue from "vue";

Vue.filter("date", value => {
  let unix = Date.parse(value);
  let date = new Date(unix);

  let day = date.getUTCDate();
  let month = date.getUTCMonth();
  let year = date.getUTCFullYear();

  return (
    day.toString().padStart(2, "0") +
    "-" +
    (month + 1).toString().padStart(2, "0") +
    "-" +
    year.toString()
  );
});
